import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DashboardVisitorComponent } from "./components/dashboard-visitor.component";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { AccordionModule } from "primeng/accordion";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ChartModule } from "primeng/chart";
import { OrderListModule } from "primeng/orderlist";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";

import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { DashboardVisitorService } from "./dashboard-visitor.service";
import { TodaysVisitorStatsComponent } from "./todays-visitor-stats/todays-visitor-stats.component";
import { FacilityStatsYTDComponent } from "./facility-stats-ytd/facility-stats-ytd.component";
import { DistrictStatsYTDComponent } from "./district-stats-ytd/district-stats-ytd.component";
import { VisitorGraphComponent } from "./visitor-graph/visitor-graph.component";
import { VisitorDeniedComponent } from "./visitor-denied/visitor-denied.component";

@NgModule({
	declarations: [
		DashboardVisitorComponent,
		TodaysVisitorStatsComponent,
		FacilityStatsYTDComponent,
		DistrictStatsYTDComponent,
		VisitorGraphComponent,
		VisitorDeniedComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		AccordionModule,
		ScrollPanelModule,
		ChartModule,
		OrderListModule,
		TableModule,
		DropdownModule,
		SchoolselectorModule,
	],
	providers: [DashboardVisitorService],
})
export class DashboardVisitorModule {}
